import * as React from 'react';
export const momoSvg = React.forwardRef(function momoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('rect', {
      width: '16',
      height: '16',
      rx: '3.5',
      fill: '#A50064',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.5155 7.56963C12.9069 7.56963 14.0002 6.47633 14.0002 5.08486C14.0002 3.6934 12.9069 2.6001 11.5155 2.6001C10.124 2.6001 9.03076 3.6934 9.03076 5.08486C9.03076 6.47633 10.124 7.56963 11.5155 7.56963ZM11.5155 3.96317C12.1402 3.96317 12.5804 4.46012 12.5804 5.08486C12.5804 5.70961 12.1402 6.20656 11.5155 6.20656C10.8907 6.20656 10.4506 5.70961 10.4506 5.08486C10.4506 4.46012 10.8907 3.96317 11.5155 3.96317Z',
      fill: 'white',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.41804 2.6001C6.01637 2.6001 5.60732 2.74961 5.29907 2.97253C5.0134 2.74961 4.63714 2.6001 4.24569 2.6001C3.20921 2.6001 2.3999 3.25324 2.3999 4.51692V7.49864H3.81974V4.38913C3.81974 4.14775 3.99012 3.97737 4.21729 3.97737C4.44447 3.97737 4.61485 4.14775 4.61485 4.38913V7.49864H6.03469V4.38913C6.03469 4.14775 6.20507 3.97737 6.43224 3.97737C6.65941 3.97737 6.8298 4.14775 6.8298 4.38913V7.49864H8.24963V4.51692C8.24963 3.25324 7.42613 2.6001 6.41804 2.6001Z',
      fill: 'white',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.5155 8.42139C10.124 8.42139 9.03076 9.51468 9.03076 10.9062C9.03076 12.2976 10.124 13.3909 11.5155 13.3909C12.9069 13.3909 14.0002 12.2976 14.0002 10.9062C14.0002 9.51468 12.9069 8.42139 11.5155 8.42139ZM11.5155 12.0278C10.8907 12.0278 10.4506 11.5309 10.4506 10.9062C10.4506 10.2814 10.8907 9.78446 11.5155 9.78446C12.1402 9.78446 12.5804 10.2814 12.5804 10.9062C12.5804 11.5309 12.1402 12.0278 11.5155 12.0278Z',
      fill: 'white',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.41804 8.42139C6.01637 8.42139 5.60732 8.5709 5.29907 8.79382C5.0134 8.5709 4.63714 8.42139 4.24569 8.42139C3.20921 8.42139 2.3999 9.07453 2.3999 10.3382V13.3199H3.81974V10.2104C3.81974 9.96904 3.99012 9.79866 4.21729 9.79866C4.44447 9.79866 4.61485 9.96904 4.61485 10.2104V13.3199H6.03469V10.2104C6.03469 9.96904 6.20507 9.79866 6.43224 9.79866C6.65941 9.79866 6.8298 9.96904 6.8298 10.2104V13.3199H8.24963V10.3382C8.24963 9.07453 7.42613 8.42139 6.41804 8.42139Z',
      fill: 'white',
    }),
  );
});
momoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var momo = {
  category: 'brand',
  colorable: false,
  name: 'momo',
  svg: momoSvg,
};
